"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchNftHolders = fetchNftHolders;
const tslib_1 = require("tslib");
const queries_js_1 = require("./queries.js");
const client_js_1 = tslib_1.__importDefault(require("./client.js"));
async function fetchNftHolders() {
    const allEvents = [];
    let hasPreviousPage = true;
    let startCursor = null;
    let count = 0;
    while (hasPreviousPage) {
        // Assign the entire result to a variable with a type annotation
        console.log("cursor", startCursor);
        const result = await client_js_1.default.query({
            query: queries_js_1.GET_NFT_HOLDERS,
            variables: {
                before: startCursor,
                receipt: "0x9bbd650b8442abb082c20f3bc95a9434a8d47b4bef98b0832dab57c1a8ba7123::alphapool::Receipt",
            },
        });
        // Now destructure from the properly typed variable
        const data = result.data;
        if (!data)
            break;
        const { nodes, pageInfo } = data.objects;
        for (const node of nodes) {
            console.log(node.asMoveObject.contents.json.owner, node.asMoveObject.contents.json.pool_id, node.asMoveObject.contents.json.xTokenBalance);
        }
        hasPreviousPage = pageInfo.hasPreviousPage;
        startCursor = pageInfo.startCursor;
        console.log(count++);
    }
    return allEvents;
}
//# sourceMappingURL=fetchNftHolders.js.map